module.exports = __webpack_public_path__ + "img/AuditFailed.bf3a8325.png";